import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideInvalidData'
})
export class HideInvalidDataPipe implements PipeTransform {

  transform(value: string, field: 'dataNascita' | 'luogoNascita'): string {
    if (field === 'dataNascita' && value === '0001-01-01') {
      return '';
    }
    if (field === 'luogoNascita' && value === 'GASPARI') {
      return '';
    }
    return value;
  }
}
